const instagramHandle = /^[a-z0-9_][a-z0-9_.]{0,29}$/;
const reserved = new Set([
  "accounts", "p", "reel", "reels", "stories", "explore", "direct", "about",
  "developer", "developers", "privacy", "legal", "challenge", "oauth", "web",
  "login", "logout", "signup", "checkpoint", "settings", "search", "intent",
  "home", "watch", "groups", "marketplace", "share", "sharer.php", "topics",
  "orgs", "features",
]);

/** Build only a local card destination. Public preview never claims a profile. */
export function instagramCardTarget(value: string): string {
  const input = value.trim();
  let handle = input.replace(/^@/, "").toLowerCase();
  if (!input || input.length > 256 || /[\x00-\x20\x7f\\%]/.test(input)) {
    throw new Error("Enter your Instagram handle or a public Instagram profile link.");
  }
  if (/^https:\/\//i.test(input)) {
    // Check the authority before URL parsing, which removes an explicit :443.
    if (!/^https:\/\/(?:www\.)?instagram\.com\/[^/?#]+\/?$/i.test(input)) {
      throw new Error("Use an Instagram profile link, without extra paths or parameters.");
    }
    const url = new URL(input);
    handle = url.pathname.replace(/^\/|\/$/g, "").toLowerCase();
  }
  if (!instagramHandle.test(handle) || reserved.has(handle)) {
    throw new Error("Use an Instagram profile handle, up to 30 characters. Post and reel links are not profile links.");
  }
  const query = new URLSearchParams({
    source: "instagram",
    profileURL: `https://www.instagram.com/${handle}/`,
  });
  return `/@${handle}?${query}`;
}

export function navigateToSocialCard(target: string) {
  window.location.assign(target);
}
